<div class="idle-countdown-overlay">
  <div class="idle-countdown-modal">
    <div class="idle-countdown-header">
      
      <h2>Session Timeout Warning</h2>
      <p>Your session will expire due to inactivity</p>
    </div>

    <div class="idle-countdown-body">
      <div class="countdown-display">
        <div class="time-display" [class.warning]="remainingSeconds <= 30">{{ getTimeDisplay() }}</div>
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
        </div>
      </div>

      <div class="countdown-message">
        <p>
          You will be automatically logged out in <strong>{{ minutes }}m {{ seconds }}s</strong>
        </p>
        <p>Click "Stay Logged In" to extend your session</p>
      </div>
    </div>

    <div class="idle-countdown-actions">
      <button type="button" class="btn btn-secondary" (click)="onLogout()">Logout Now</button>
      <button type="button" class="btn btn-primary" (click)="onExtend()">Stay Logged In</button>
    </div>
  </div>
</div>
